import React from "react";
import StandardModal from "./shared/StandardModal";

function GoogleSyncErrorModal({ open, close, error = "" }) {
	const formattedError = `${error.charAt(0).toUpperCase()}${error.slice(1)}${error.endsWith(".") ? "" : "."}`;
	return (
		<StandardModal size="medium" title="Google Sync Error" open={open} close={close}>
			<div>
				<div className="text-red text-bold">{formattedError}</div>
			</div>
		</StandardModal>
	);
}

export default GoogleSyncErrorModal;
